module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-cjdr-24.11ef443a.jpg";